import { render, staticRenderFns } from "./Popupcart.vue?vue&type=template&id=a916e274&scoped=true&"
import script from "./Popupcart.vue?vue&type=script&lang=js&"
export * from "./Popupcart.vue?vue&type=script&lang=js&"
import style0 from "./Popupcart.vue?vue&type=style&index=0&id=a916e274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a916e274",
  null
  
)

export default component.exports